
import React from "react";
import { Classname } from "@rivtn/noseur";
import styles from "../../assets/style.module.css";

export interface SectionHeadProps {
    tag: string;
    title: string;
    as?: "h1" | "h2";
    action?: React.ReactNode;
    align?: "left" | "center";
}

function SectionHead({ tag, title, action, align = "left", as: Heading = "h2" }: SectionHeadProps) {
    return (<div className={Classname.build(styles["sec-head"], styles[`sec-head-${align}`])}>
        <div className={styles["sec-head-text"]}>
            <span className={styles["tag"]}>{tag}</span>
            <Heading className={styles["h-02"]}>{title}</Heading>
        </div>
        {action}
    </div>);
}

export default SectionHead;
